import React, {Component} from 'react';
import PropTypes from 'prop-types';

const $ = window.jQuery;

class Dropdown extends Component {
    static propTypes = {
        dataSource: PropTypes.object.isRequired,
        requestData: PropTypes.object,
        placeholder: PropTypes.string,
        item: PropTypes.object,
        templateResult: PropTypes.func,
        templateSelection: PropTypes.func,
        onChange: PropTypes.func
    };
    static defaultProps = {
        requestData: {},
        placeholder: 'Выберите значение'
    };
    state = {
        id: 0,
        item: this.props.item
    };

    componentDidMount() {
        const {dataSource, placeholder, onChange} = this.props;

        this.$el = $(this.el);
        this.$el.select2({
            placeholder,
            minimumInputLength: 0,
            width: "100%",
            language: "ru",
            ajax: {
                transport: (params, success, failure) => {
                    const {requestData} = this.props;

                    dataSource.call({
                            ...requestData,
                            searchState: {
                                term: params.data.term,
                                paging: {
                                    pageIndex: (params.data.page || 1) - 1,
                                    pageSize: 10
                                },
                            }
                        })
                        .then(success, failure);
                },
                processResults: (data, params) => {
                    params.page = params.page || 1;
                    return {
                        results: data.items,
                        pagination: {
                            more: (params.page * 10) < data.totalCount,
                            page: params.page
                        }
                    };
                }
            },
            templateResult: this.props.templateResult,
            templateSelection: this.props.templateSelection,
            dropdownParent: this.$el.closest('.modal').length
                ? this.$el.closest('.modal')
                : undefined
        });
        this.$el.on('change', event => onChange(event, this.$el.select2('data')));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.value && nextProps.value === null)
            this.$el.val(null).trigger('change');
        this.setState({item: nextProps.item});
    }

    componentWillUnmount() {

    }

    render() {
        const {dataSource, requestData, item, value, onChange, ...props} = this.props;
        return (
            <select ref={el => this.el = el} data-allow-clear="true" {...props}>
                {this.state.item && <option value={this.state.item.id}>{this.state.item.text}</option>}
            </select>
        );
    }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/controls/Dropdown.js